module.exports = __webpack_public_path__ + "img/optimization.c95bbe64.png";